import { render, staticRenderFns } from "./scrisoareMedicalaModal.vue?vue&type=template&id=2f4ed8d0"
import script from "./scrisoareMedicalaModal.vue?vue&type=script&lang=js"
export * from "./scrisoareMedicalaModal.vue?vue&type=script&lang=js"
import style0 from "./scrisoareMedicalaModal.vue?vue&type=style&index=0&id=2f4ed8d0&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports